import { defineComponent as _defineComponent } from 'vue'
import BankAccountsTable from 'ah-beneficiaries/src/components/bankAccounts/BankAccountsTable.vue';
import BankAccountEditModal from 'ah-beneficiaries/src/components/bankAccounts/BankAccountEditModal.vue';
import BankAccountInfo from 'ah-beneficiaries/src/components/bankAccounts/BankAccountInfo.vue';
import { AuthorityType, Beneficiary } from 'ah-api-gateways';
import {
  bankAccountsTableFields,
  narrowBankAccountsTableFields,
} from 'ah-beneficiaries/src/models/bankAccountsTableFields';
import { AnimatedListingWithSubViewState } from '@/app/components/common/animation/AnimatedListingWithSubView.vue';
import { mergeMap } from 'rxjs/operators';
import { waitForEntityDeletion } from 'ah-requests';
import { useIndividualSettingsStore } from '@/app/store/individualSettingsModule';
import { computed, ref } from 'vue';
import { useAuthStore } from '@/app/store/authModule';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { getServices } from '@/app/services';
import { useMediaQuery } from 'ah-common-lib/src/mediaQuery';


export default /*#__PURE__*/_defineComponent({
  __name: 'BankAccountsSettingsView',
  setup(__props) {

const mediaQuery = useMediaQuery();

const requestManager = useRequestManager().manager;

const services = getServices();

const selectedBeneficiary = ref<Beneficiary>();

// Auto-set by AnimatedListingWithSubView[animatedState.sync] in template
const animatedState = ref<AnimatedListingWithSubViewState>();

const canManageBeneficiaries = computed(() => useAuthStore().hasAuthorities(AuthorityType.MANAGE_BENEFICIARIES));

const individualSettingsStore = useIndividualSettingsStore();

const beneficiaries = computed(() => individualSettingsStore.selfBeneficiaries);

const tableFields = computed(() => {
  return mediaQuery.is('mdDown') && !animatedState.value?.wideList
    ? narrowBankAccountsTableFields
    : bankAccountsTableFields;
});

const reqManagerState = computed(() => {
  if (requestManager.isAnyInState('error')) return 'error';
  if (requestManager.isAnyInState('pending')) return 'pending';
  return 'idle';
});

function openBeneficiary(beneficiary: Beneficiary) {
  if (selectedBeneficiary.value === beneficiary) {
    selectedBeneficiary.value = undefined;
  } else {
    selectedBeneficiary.value = beneficiary;
  }
}

function onBeneficiaryUpdated(beneficiary?: Beneficiary) {
  if (selectedBeneficiary.value && selectedBeneficiary.value.id === beneficiary?.id) {
    selectedBeneficiary.value = beneficiary;
  }
  loadBeneficiaries();
}

function loadBeneficiaries() {
  requestManager.newPromise('loadBeneficiaries', individualSettingsStore.loadSelfBeneficiaries(true));
}

function removeBankAccount(beneficiary: Beneficiary) {
  if (beneficiaries.value) {
    requestManager
      .currentOrNew(
        `deleteBeneficiary-${beneficiary.id}`,
        services.beneficiary
          .deleteBeneficiary(beneficiary.id)
          .pipe(
            mergeMap(() =>
              waitForEntityDeletion(
                () => services.beneficiary.getBeneficiary(beneficiary.id, { errors: { silent: true } }),
                { retries: 30 }
              )
            )
          )
      )
      .subscribe(() => {
        if (selectedBeneficiary.value?.id === beneficiary.id) {
          selectedBeneficiary.value = undefined;
        }
        loadBeneficiaries();
      });
  }
}

loadBeneficiaries();

return { __sfc: true,mediaQuery, requestManager, services, selectedBeneficiary, animatedState, canManageBeneficiaries, individualSettingsStore, beneficiaries, tableFields, reqManagerState, openBeneficiary, onBeneficiaryUpdated, loadBeneficiaries, removeBankAccount, BankAccountsTable, BankAccountEditModal, BankAccountInfo }
}

})